import { useId } from 'react';
import { PAY_TYPES } from '../../constants/castingCallOptions';

const payTypes = new Set(PAY_TYPES.map(({ value }) => value));
export function roleCompensation(role = {}, casting = {}) {
  const overridden = payTypes.has(role.pay_type);
  const type = overridden ? role.pay_type : casting.pay_type;
  const amount = overridden ? role.pay_amount : casting.pay_amount;
  const label = PAY_TYPES.find(({ value }) => value === type)?.label || 'To Be Confirmed';
  return { overridden, type, amount: typeof amount === 'string' ? amount.trim() : '', label };
}
export function roleCompensationText(role, casting) {
  const { label, amount } = roleCompensation(role, casting);
  return `${label}${amount ? ` · ${amount}` : ''}`;
}

export default function RoleCompensationFields({ role, casting, onChange }) {
  const id = useId();
  const { overridden } = roleCompensation(role, casting);
  return <fieldset className="space-y-2 rounded-xl border border-theme p-3">
    <legend className="px-1 text-sm font-semibold text-theme-text">Pay for this role</legend>
    <label htmlFor={`${id}-type`} className="block text-xs text-theme-muted">Payment terms</label>
    <select id={`${id}-type`} value={overridden ? role.pay_type : ''} onChange={(event) => {
      onChange('pay_type', event.target.value || null);
      if (!event.target.value) onChange('pay_amount', null);
    }} className="min-h-11 w-full rounded-lg border border-theme bg-theme-bg-secondary px-3 text-base text-theme-text sm:text-sm">
      <option value="">Use casting-wide pay</option>
      {PAY_TYPES.map(({ value, label }) => <option key={value} value={value}>{label}</option>)}
    </select>
    {overridden && <>
      <label htmlFor={`${id}-amount`} className="block text-xs text-theme-muted">Rate and expenses for this role</label>
      <input id={`${id}-amount`} value={role.pay_amount || ''} maxLength={500} onChange={(event) => onChange('pay_amount', event.target.value)} placeholder="e.g. £350 per day + travel" className="min-h-11 w-full rounded-lg border border-theme bg-theme-bg-secondary px-3 text-base text-theme-text sm:text-sm" />
    </>}
    <p className="break-words text-xs text-theme-muted">{overridden ? 'Role-specific terms' : 'Uses casting-wide terms'}: {roleCompensationText(role, casting)}</p>
  </fieldset>;
}
